import { Select } from '@/components/Select';
import type { JobTaskStatus } from '@maker-toolchest/shared';

interface TaskFiltersProps {
  status?: JobTaskStatus | '';
  onStatusChange: (value: JobTaskStatus | '') => void;
}

const taskStatusOptions = [
  { value: '', label: 'All Statuses' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'QUEUED', label: 'Queued' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'CANCELLED', label: 'Cancelled' },
];

export function TaskFilters({ status = '', onStatusChange }: TaskFiltersProps) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-medium text-foreground">Filter by Status:</span>
      <div className="w-48">
        <Select
          value={status}
          onChange={(e) => onStatusChange(e.target.value as JobTaskStatus | '')}
          options={taskStatusOptions}
        />
      </div>
    </div>
  );
}
